import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from "react";
import { removeBaseEndpoint } from "@/helpers/Helpers";
import ChatItemHrefButtons from "./ChatItemHrefButtons";
import { useLinkPreviewContext } from "./LinkPreviewContext";
interface LinkHandlerFrameProps {
  readonly href: string;
  readonly children: ReactNode;
  readonly hideLink?: boolean | undefined;
  readonly relativeHref?: string | undefined;
  readonly overlayAnchor?: "frame" | "content" | undefined;
}
export default function LinkHandlerFrame(t0) {
  const $ = _c(18);
  const {
    href,
    children,
    hideLink: t1,
    relativeHref,
    overlayAnchor: t2
  } = t0;
  const hideLink = t1 === undefined ? false : t1;
  const overlayAnchor = t2 === undefined ? "frame" : t2;
  const {
    hideActions
  } = useLinkPreviewContext();
  let t3;
  if ($[0] !== href || $[1] !== relativeHref) {
    t3 = relativeHref ?? (() => {
      const relative = removeBaseEndpoint(href);
      return relative.startsWith("/") ? relative : undefined;
    })();
    $[0] = href;
    $[1] = relativeHref;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const effectiveRelativeHref = t3;
  let t4;
  if ($[3] !== effectiveRelativeHref || $[4] !== hideActions || $[5] !== hideLink || $[6] !== href) {
    t4 = hideActions ? null : <ChatItemHrefButtons href={href} hideLink={hideLink} relativeHref={effectiveRelativeHref} layout="overlay" />;
    $[3] = effectiveRelativeHref;
    $[4] = hideActions;
    $[5] = hideLink;
    $[6] = href;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const actionButtons = t4;
  const shouldAnchorOverlayToContent = overlayAnchor === "content" && actionButtons !== null;
  if (shouldAnchorOverlayToContent) {
    let t5;
    if ($[8] !== children) {
      t5 = <div className="tw-min-w-0 tw-max-w-full tw-overflow-hidden focus-within:tw-overflow-visible">{children}</div>;
      $[8] = children;
      $[9] = t5;
    } else {
      t5 = $[9];
    }
    let t6;
    if ($[10] !== actionButtons || $[11] !== t5) {
      t6 = <div className="tw-flex tw-w-full tw-min-w-0 tw-max-w-full"><div className="tw-group/link-card tw-relative tw-inline-flex tw-w-fit tw-min-w-0 tw-max-w-full tw-flex-col">{t5}{actionButtons}</div></div>;
      $[10] = actionButtons;
      $[11] = t5;
      $[12] = t6;
    } else {
      t6 = $[12];
    }
    return t6;
  }
  let t5;
  if ($[13] !== children) {
    t5 = <div className="tw-min-w-0 tw-max-w-full tw-overflow-hidden focus-within:tw-overflow-visible">{children}</div>;
    $[13] = children;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== actionButtons || $[16] !== t5) {
    t6 = <div className="tw-group/link-card tw-relative tw-w-full tw-min-w-0 tw-max-w-full">{t5}{actionButtons}</div>;
    $[15] = actionButtons;
    $[16] = t5;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  return t6;
}